<template>
    <div>
        <div class="title">投保信息</div>
        <Form :model="form" :label-width="110" ref="form" class="mt15" :rules="formRules">
            <FormItem label="项目名称：" prop="projectName" class="w600">
                <Input v-model="form.projectName" placeholder="请输入项目名称" :maxlength="50"></Input>
            </FormItem>
            <FormItem label="项目编码：" prop="projectCode" class="w600">
                <Input v-model="form.projectCode" placeholder="请输入项目编码" :maxlength="50"></Input>
            </FormItem>
            <FormItem label="保证金金额：" prop="insuranceAmount" class="w600">
                <Input v-model="form.insuranceAmount" placeholder="金额不大于80万" @on-blur="getPremium"></Input>
            </FormItem>
            <FormItem label="起保日期：" class="w600" prop="effectiveDateStart">
                <DatePicker v-model="form.effectiveDateStart" type="date" placeholder="请选择起保日期" style="width: 100%"
                    @on-change="dateChange" :options="dateOptions">
                </DatePicker>
            </FormItem>
            <FormItem label="终保日期：" class="w600" prop="effectiveDateEnd">
                <DatePicker v-model="form.effectiveDateEnd" type="date" placeholder="请选择终保日期" style="width: 100%"
                :disabled="!form.effectiveDateStart" @on-change="dateChanges" :options="endDateOptions">
                </DatePicker>
            </FormItem>
        </Form>
    </div>
</template>
<script>
    import SelectJob from '@/components/common/SelectJob'
    export default {
        components: { SelectJob },
        props: {
            info: Object,
            formInfo: Object
        },
        data () {
            const validatePrice = (rule, val, cb) => {
                if (!this.rules.price.test(val)) {
                    cb(new Error('金额为非负数字且最多保留两位小数'));
                } else if(Number(val)>800000){
                    cb(new Error('金额不得大于800000'));
                } else {
                    cb();
                }
            }
            return {
                premium: '',//预估保费
                id: this.$route.params.id,
                isRenew: this.$route.query.renew || '',
                form: {},
                dateOptions: {},
                endDateOptions: {},
                formRules: {
                    effectiveDateStart: [{
                        required: true, message: '请选择起保日期', type: 'date', validator: (rule, value, callback) => {
                            if (value) {
                                callback()
                            } else {
                                callback(new Error())
                            }
                        }
                    }],
                    effectiveDateEnd: [{
                        required: true, message: '请选择终保日期', type: 'date', validator: (rule, value, callback) => {
                            if (value) {
                                callback()
                            } else {
                                callback(new Error())
                            }
                        }
                    }],
                    projectCode: [{ required: true, message: '项目编码必填', trigger: 'change' }],
                    projectName: [{ required: true, message: '项目名称必填', trigger: 'blur' }],
                    insuranceAmount: [
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        { validator: validatePrice, trigger: 'blur' }
                    ]
                }
            }
        },
        computed: {},
        watch: {
            info(v) {
                this.setData();
                if (v.productCode) {
                    this.setStartTimeOption();
                }
            }
        },
        created () {
            this.setData()
            if (!this.isRenew) {
                this.setStartTimeOption();
            }

        },
        methods: {
            setData() {
                this.form = this.info;
                if(this.info.extraInfo){
                    this.form.projectCode = this.info.extraInfo.projectCode;
                    this.form.projectName = this.info.extraInfo.projectName;
                }
                this.getPremium();
            },
            async setStartTimeOption (val) {
                if (!this.isRenew) {
                    let res = await this.getEffectiveDateEnd(val?val:this.formatDate(new Date()), 2, 'start');
                    this.dateOptions = {
                        disabledDate (date) {
                            return date && (date.valueOf() < Date.parse(res.effectiveStartDateStart + ' 00:00:00'))
                        }
                    }
                    this.endDateOptions ={
                        disabledDate (date) {
                            return date && (date.valueOf() < Date.parse(res.effectiveStartDateStart + ' 00:00:00')||date.valueOf()>Date.parse(res.effectiveStartDateEnd + ' 00:00:00'))
                        }
                    }
                }
            },
            // 计算保费
            getPremium () {
                if (!this.form.insuranceAmount) return
                this.$axios.post('/broker/quote.json', {
                    insuranceAmount: this.form.insuranceAmount,
                    productCode: this.$route.query.productCode || this.info.productCode,
                    bizId: 'JIANGONG_EMPLOYER_LIABILITY',
                }).then(res => {
                    console.log('保费计算', res)
                    this.premium = res.premium
                    this.$emit('set-amount', res.premium)
                })
            },
            // 校验
           val () {
                return new Promise((resolve, rejct) => {
                    this.$refs.form.validate(valid => {
                        resolve(valid ? {
                            productCode: this.$route.query.productCode || this.info.productCode,
                            effectiveDateStart:this.formatDate(this.form.effectiveDateStart),
                            effectiveDateEnd:this.formatDate(this.form.effectiveDateEnd),
                            insuranceAmount:this.form.insuranceAmount,
                            insurancePeriod: (Math.abs(parseInt((new Date(this.form.effectiveDateEnd).getTime() - new Date(this.form.effectiveDateStart).getTime()) / (1000 * 60 * 60 * 24)))),
                            extraInfo:{
                                projectCode: this.form.projectCode,
                                projectName: this.form.projectName
                            }
                        } : false)
                    })
                })
            },
            /*日期变化后获取起保终保日期*/
            dateChange (val) {
                this.$set(this.form,'effectiveDateStart',val);
                this.$set(this.form,'effectiveDateEnd','');
                this.setStartTimeOption(val);
            },
            dateChanges (val) {
                this.form.effectiveDateEnd = val
                this.$set(this.form,'effectiveDateEnd',val);
            },
            // 获取保障止期，父页面fillin也会用到
            getEffectiveDateEnd (effectiveDateStart, insuredPeriod, type = 'end') {
                console.log(' this.info.productCode', this.info.productCode)
                return this.$axios.post('/broker/insurance/application/getEffectiveDateStartRange.json', {
                    effectiveDateStart: effectiveDateStart,
                    insuredPeriod: insuredPeriod,
                    productCode: 'JIANGONG_DEPOSIT'
                }).then(res => {
                    return res
                })
            }

        }
    }
</script>
<style scoped lang="less">
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/RecognizeCompany.vue